module.exports = __webpack_public_path__ + "static/media/dislike_clicked.d53a0176.png";